import { ReactNode } from "react";

interface IIconPillTagProps {
  color: string;
  icon: ReactNode;
  children: ReactNode;
}

/**
 * Small colored pill pairing a tiny bordered icon circle with a label —
 * rounded-full, border + 20%-opacity fill wash in `color`, Inter 10px text.
 * Color-parameterized only; icon and label are fully caller-controlled via
 * `icon`/`children`, so any status/confirmation tag with this exact shape
 * (e.g. "Pronta"/"Reprovada" in `PlanilhaValidationTable`, "Lote importado"
 * in `BatchCreatedAppointments`) should reuse this instead of re-inlining
 * the pill shell. Not a fit for a plain text pill with no icon slot — see
 * `StatusTagV2` for that shape (used for `StatusAgendamentoEnum`).
 */
export const IconPillTag = ({ color, icon, children }: IIconPillTagProps) => (
  <span
    className="inline-flex items-center gap-2 rounded-full border border-solid p-1 font-['Inter'] text-[10px] font-normal leading-[12px]"
    style={{ borderColor: color, backgroundColor: `${color}33`, color }}
  >
    <span
      className="flex h-2.5 w-2.5 shrink-0 items-center justify-center rounded-full border border-solid"
      style={{ borderColor: color }}
    >
      {icon}
    </span>
    {children}
  </span>
);
